import { gql } from "@apollo/client";

export const GET_TICKET = gql`
  query GET_TICKET($ticketId: ID!, $originatorId: ID!) {
    getTicket(ticketId: $ticketId, originatorId: $originatorId) {
      id
      ticketNumber
      isWarning
      bacValue
      currentStatus
      driversLicense
      violationOccurrence {
        id
        name
      }
      weightLimit {
        id
        name
      }
      state {
        id
        name
      }
      stateTxt
      licenseStateName
      incident {
        id
        incidentNumber
        ori {
          id
          oriName
        }
        personIncidentSpecifics {
          id
          sealed
          bac
          juvenile
          yoe
          person {
            id
            personalAttribute {
              id
              firstName
              lastName
              homeAddress {
                id
                name
              }
              mailingAddress {
                id
                name
              }
            }
          }
        }
        officerIncidentSpecifics {
          id
          officer {
            id
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
                oriName
                municipalityNumber
              }
            }
            personalAttribute {
              id
              lastName
              firstName
            }
          }
        }
        vehicleIncidentSpecifics {
          id
          vehicle {
            id
            vehicleMake {
              id
              nhtsaId
              name
            }
            vehicleModel {
              id
              nhtsaId
              name
            }
            vehiclePlate {
              id
              name
            }
          }
        }
      }
      code
      penalty
      ticketViolationPrototype {
        code
        fullName
        name
        id
        maxPenalty
        minPenalty
        oriId
        points
        section
        statute
        title
        ticketEntry {
          id
          name
        }
        civilViolation
        municipalOrdinance
        speedingVio
        doNotSubmit
        ticketCategory {
          id
          name
        }
        ticketSubCategory {
          id
          name
        }
        waiver
      }
      highway {
        id
        name
      }
      ticketCondition {
        id
        lightingConditions {
          id
          name
        }
        roadConditions {
          id
          name
        }
        trafficConditions {
          id
          name
        }
        weatherConditions {
          id
          name
        }
      }
      ticketLocation {
        city
        id
        lat
        lng
        name
        state
        streetName
        streetNumber
        unit
        zip
      }
      municipality {
        id
        name
      }
      violationDate
      ticketDeliveryType {
        id
        name
      }
      issuedTo {
        id
        personalAttribute {
          id
          firstName
          lockedFirstName
          lastName
          lockedLastName
          middleName
          lockedMiddleName
          driversLicense
          lockedLicense
          fishWildlifeLicense
          lockedFishWildlifeLicense
          phone
          lockedPrimaryPhone
          cell
          lockedCell
          dob
          lockedDob
          juvenile
          height
          lockedHeight
          weight
          lockedWeight
          pobAddress {
            name
          }
          lockedPobAddress {
            name
          }
          gender {
            id
            name
          }
          lockedGender {
            id
            name
          }
          hairColor {
            id
            name
          }
          lockedHairColor {
            id
            name
          }
          eyeColor {
            id
            name
          }
          lockedEyeColor {
            id
            name
          }
          organization
          lockedOrganization
          mailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          lockedMailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          licenseState {
            id
            name
            oriId
            position
          }
          lockedLicenseState {
            id
            name
            oriId
            position
          }
        }
      }
      issuedAt
      issuedToAddress {
        city
        id
        lat
        lng
        name
        state
        streetName
        streetNumber
        unit
        zip
      }
      mailingAddressVerified
      officer {
        id
        deptAttribute {
          id
          stateIdNumber
          ori {
            id
            oriName
            abbreviation
            oriName
            municipalityNumber
          }
          badge
        }
        personalAttribute {
          firstName
          middleName
          lastName
        }
      }
      trespassRequestor {
        id
        personalAttribute {
          firstName
          lastName
          middleName
        }
      }
      actualSpeed
      postedLimit
      waiver
      points
      penaltyMin
      penaltyMax
      ticketStatus {
        id
        name
      }
      cvHazardFee
      federalViolationCode {
        id
        name
      }
      dispositionPenaltyAmount
      defendantActions
      seatBeltOccurrence
      cdl
      reliefActType {
        id
        name
      }
      reliefActComment
      defendantParent {
        id
        personalAttribute {
          id
          firstName
          lastName
          mailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          homeAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
        }
      }
      deliveredToType {
        id
        name
      }
      operator {
        id
        personalAttribute {
          id
          firstName
          middleName
          lastName
        }
      }
      municipalOrdinance
      vehicle {
        id
        year
        vehicleState {
          id
          name
        }
        vehicleMake {
          id
          nhtsaId
          name
        }
        vehicleModel {
          id
          nhtsaId
          name
        }
        vehiclePlate {
          id
          name
        }
        vehicleColor {
          id
          name
        }
        validVehicleAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          vehicle {
            id
          }
        }
      }
      perceivedRace {
        id
        name
      }
      ticketStopType {
        id
        name
      }
      ticketSearchType {
        id
        name
      }
      ticketEvidenceType {
        id
        name
      }
      ticketOutcomeType {
        id
        name
      }
      passengerTicketSearchType {
        id
        name
      }
      passengerTicketEvidenceType {
        id
        name
      }
      passengerTicketOutcomeType {
        id
        name
      }
      accident
      hazmat
      fatality
      commercialVehicle
      relativeCrimeCharge
      narrative
      trespassUntil
      uofInstance {
        id
        name
      }
      uofInjuryDetails {
        id
        name
      }
      uofInstanceTypes {
        id
        name
      }
    }
  }
`;
